/**
 * Iterate over invalid fields, and highlight the container
 * @param validation
 * @param requiredFields
 */
function highlightFields(validation, requiredFields) {
  if (!validation.errors) {
    return;
  }
  validation.errors.forEach((error) => {
    if (requiredFields[error.field] !== undefined) {
      requiredFields[error.field] = true;
    }
  });
}

/**
 * Iterate over valid fields, and clear the container
 * @param validation
 * @param requiredFields
 */
function clearHighlightFields(validation, requiredFields) {
  if (!validation.passedRecords) {
    return;
  }
  validation.passedRecords.forEach((passedRecord) => {
    if (requiredFields[passedRecord.field] !== undefined) {
      requiredFields[passedRecord.field] = false;
    }
  });
}

module.exports = {
  highlight: highlightFields,
  clear: clearHighlightFields,
};
